import { Breadcrumbs, Grid, Typography } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import React, { useEffect, useState } from "react";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import EventConfig from "../../components/EventConfig/EventConfig";
import { getTTSIntentDetail } from "../../../../apis/TTS/intent.api";

export const showBreadCrumb = (intent, eventType) => {
  let typeIntentConfigText = "Success Intent";
  let colorText = "#1976d2";

  if (eventType === "error") {
    typeIntentConfigText = "Error Intent";
    colorText = "#ed6c02";
  }

  if (intent) {
    console.log("🚀 ~ showBreadCrumb ~ intent:", intent);
    const { ttsEvent, ttsContext } = intent;
    let title = `intent không được xác định, vui lòng tạo mới`;
    if (ttsEvent && ttsContext) {
      title = `${ttsEvent?.eventNamespace} - ${ttsEvent?.eventName} - ${ttsContext?.contextNamespace} - ${ttsContext?.contextName}`;
    }
    return (
      <p style={{ padding: "10px", fontWeight: "bold", display: "flex" }}>
        <span
          style={{ color: colorText }}
        >{`edit ${typeIntentConfigText}`}</span>
        <ArrowRightAltIcon />
        <span>{title}</span>
      </p>
    );
  }

  return (
    <p style={{ padding: "10px", fontWeight: "bold" }}>
      <span
        style={{ color: colorText }}
      >{`add new ${typeIntentConfigText}`}</span>
    </p>
  );
};

const TTSIntentConfig = () => {
  let { id } = useParams();
  const location = useLocation();

  // Parse the query parameters
  const queryParams = new URLSearchParams(location.search);
  const eventType = queryParams.get("eventType") || "success";

  const [intent, setIntent] = useState(null);

  useEffect(() => {
    if (id) {
      getTTSIntentDetail(id, (result) => {
        setIntent({ ...result });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          color="text.primary"
          component={"span"}
          textTransform="capitalize"
          fontWeight="bold"
        >
          {showBreadCrumb(intent, eventType)}
        </Typography>
      </Breadcrumbs>
      <div style={{ marginTop: "40px" }}>
        <Grid container>
          <Grid item xs={12} p={5} container>
            <EventConfig />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default TTSIntentConfig;
